import React, { useState, useRef } from "react";
import InfoBox from "./InfoBox.jsx";
import { ActiveInput, ActiveLabel, DisabledInput, DisabledLabel,ErrorInput, ErrorLabel } from "./Util.jsx";
import { X, Eye, EyeClosed } from "lucide-react";

const Input = ({ label, value, setValue, blurAction = null, keyDownAction = null, type, disabled = false, error = false, readOnly = false, classes = '', info = false, infotext = '', infopos = 'r', infoclass = '', infosize = 20 }) => {
    const inputRef = useRef(null);
    const [togglePassword, setTogglePassword] = useState(false);
    const isPasswordType = type === "password";

    return (
        <div className={`relative ${classes}`}>
            <input
                type={isPasswordType ? (togglePassword ? "text" : "password") : type}
                ref={inputRef}
                className={disabled === true ? DisabledInput : error === true ? ErrorInput : ActiveInput}
                placeholder=" "
                value={value}
                onChange={(e) => setValue(e.target.value)}
                disabled={disabled === true}
                readOnly={readOnly === true}
                onBlur={(e) => {
                    if (blurAction) {
                        blurAction(e);
                    }
                }}
                onKeyDown={(e) => {
                    if (keyDownAction) {
                        keyDownAction(e);
                    }
                }}
                {...(type === "number" && { step: "0.01" })}
            />
            <label className={`hover:cursor-text rounded-lg ${disabled === true ? DisabledLabel : error === true ? ErrorLabel : ActiveLabel}`} onClick={() => {
                if (disabled === false) {
                    inputRef.current.focus();
                }
            }}> {label} </label>
            
            {value !== '' && !readOnly && !disabled && (
                <div className="absolute inset-y-0 right-0 pr-1 flex items-center text-gray-700 dark:text-neutral-300 hover:cursor-pointer" onClick={() => setValue(null)}>
                    <X size={20} />
                </div>
            )}
            
            {isPasswordType && value !== '' && (
                <div className={`absolute inset-y-0 ${disabled ? 'right-0' : 'right-6'} pr-1 flex items-center text-gray-700 dark:text-neutral-300 hover:cursor-pointer`} onClick={() => setTogglePassword(!togglePassword)}>
                    {togglePassword ? <EyeClosed size={20} /> : <Eye size={20} />}
                </div>
            )}
            
            {info && (
                <div className="absolute inset-y-0 -right-6 flex items-center hover:cursor-pointer">
                    <InfoBox text={infotext} position={infopos} size={infosize} classes={infoclass} />
                </div>
            )}
        </div>
    )
}

export default Input;